import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";
import {GroupApiModel} from "./group-api-model";

export class GroupDomainModel extends BaseDomainModel {
  apiModel: GroupApiModel;

  get num(): Number {
    return this.apiModel.num;
  }

  get name(): String {
    return this.apiModel.name;
  }

  get nameForURL(): String {
    return this.apiModel.nameForURL;
  }
}